import { render } from "./ViewVesselModal.vue?vue&type=template&id=6d30ba4e"
import script from "./ViewVesselModal.vue?vue&type=script&lang=js"
export * from "./ViewVesselModal.vue?vue&type=script&lang=js"

import "./ViewVesselModal.vue?vue&type=style&index=0&id=6d30ba4e&lang=css"
script.render = render

export default script